export enum SHOPS_ACTION_TYPE {
  LIST = 'shops/list',
  CREATE = 'shops/create',
  UPDATE = 'shops/update',
  DETAIL = 'shops/detail',
  DELETE = 'shops/delete',
  STATUS = 'shops/status',
  PUBLIC_LIST = 'shops/publicList',
}
